module.exports = __webpack_public_path__ + "static/media/ceo.6442fc55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ceo.jpg
// module id = 51
// module chunks = 0